import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: decodeURIComponent(window.atob(process.env.VUE_APP_BASE_API)),
  // 超时
  timeout: 10000
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken ) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  if (config.method === 'get') {
    config.params = {
      _t: Date.parse(new Date().toString()) / 1000,
      ...config.params
    }
  }
  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']

    if (code === 401) {
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('LogOut').then(() => {
          location.href =decodeURIComponent(window.atob(process.env.VUE_APP_BASE_URL))  + decodeURIComponent(window.atob("L2NvbXBsYWludC9zeXMvYWRtaW4vbWFuYWdlbWVudC9sb2dpbg=="));
        })
      }).catch(() => {
      })

    } else if (code === 500) {
      Message({
        message: msg,
        type: 'error'
      })
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      Notification.error({
        title: msg
      })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error.response)
    let { message } = error;
    const url=  error.config.url;
    console.log('地址',url)
    console.log('是否成立',url.slice(url.lastIndexOf('/') + 1) === 'getAD')
    if(url.slice(url.lastIndexOf('/') + 1) === 'getAD'){
      Message({
        message: "对不起！您的电脑未登录到域！请通过用户名和密码进行登录!",
        type: 'warning',
        duration: 5 * 1000
      })
    }
    else if (message == "Network Error") {
      message = "后端接口连接异常";
      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }

    return Promise.reject(error)
  }
)

export default service
